import { render, staticRenderFns } from "./SelectDesign.vue?vue&type=template&id=aeb5a080&scoped=true"
import script from "./SelectDesign.vue?vue&type=script&lang=js"
export * from "./SelectDesign.vue?vue&type=script&lang=js"
import style0 from "./SelectDesign.vue?vue&type=style&index=0&id=aeb5a080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb5a080",
  null
  
)

export default component.exports